import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from '../context/AuthContext';
import Overview from '../modules/Overview/Overview';
import Portal from '../modules/Portals/Portal';
import Settings from '../modules/settings/setting';
import Users from '../modules/users/users';
import TranslationJobs from '../modules/translationJobs/translationJobs';
import PostEditing from '../modules/postEditing/postEditing';
import Resourses from '../modules/resourses/resourse';
import Translations from '../modules/translation/translations';
import Login from '../modules/auth/login';
import PortalView from '../modules/Portals/portalView';
import PortalCreate from '../modules/Portals/portalCreate';
import PrivateRoute from './privateRoute';
import ProtectedRoute from './protectedRoute';
import InviteUsers from '../modules/users/inviteUsers';
import { ToastContainer } from 'react-toastify';
import Signup from '../modules/auth/signup';
import EmailLogin from '../modules/auth/emailLogin';
import RecentTranslation from '../modules/translation/recents';
import ErrorView from '../components/ui/errorView';
import PreviewDocuments from '../modules/translation/preView';
import ApprovalRequestSent from '../modules/auth/approvalSent';
import EditUser from '../modules/users/editUser';
import UserView from '../modules/users/userView';
import Register from '../modules/company/register';
import ForgotPassword from '../modules/auth/forgotPassword';
import ResetPassword from '../modules/auth/resetPassword';
import EmailSent from '../modules/auth/emailSent';
import RegisteredSuccessfuly from '../modules/auth/registerSuccess';
import SelectVersion from '../modules/auth/selectVersion';
import RedirectLogin from '../modules/auth/redirectLogin';
import VerifyTwoFA from '../modules/auth/verifyTwoFA';
import SystemLogs from '../modules/systemLogs/systemLogs';
import SystemLogView from '../modules/systemLogs/systemLogView';
import Profile from '../modules/profile';

const IndexRoute = () => {
    return (
        <Router>
            <AuthProvider>
            <Routes>
                <Route path='/error' element={<ErrorView />} />
                <Route element={<ProtectedRoute />}>
                    <Route path='/' element={<Login />} />
                    <Route path='/sign-up' element={<Signup />} />
                    <Route path='/email-login' element={<EmailLogin />} />
                    <Route path='/forgot-password' element={<ForgotPassword />} />
                    <Route path='/reset-password/:token' element={<ResetPassword />} />
                    <Route path='/company/register' element={<Register />} />
                    <Route path='/approval-request-sent' element={<ApprovalRequestSent />} />
                    <Route path='/email-request-sent' element={<EmailSent />} />
                    <Route path='/register-success' element={<RegisteredSuccessfuly />} />
                    <Route path='/choose-version' element={<SelectVersion />} />
                    <Route path='/re-direct' element={<RedirectLogin />} />
                    <Route path='/verify-2fa' element={<VerifyTwoFA />} />
                </Route>
                <Route element={<PrivateRoute />}>
                    <Route path='/login/:id' element={<Login />} />
                    <Route path='/email-login/:id' element={<EmailLogin />} />
                    <Route path='/' element={<Overview />} />
                    <Route path='/over-view' element={<Overview />} />
                    <Route path='/portals' element={<Portal />} />
                    <Route path='/portal-view/:id' element={<PortalView />} />
                    <Route path='/settings' element={<Settings />} />
                    <Route path='/users' element={<Users />} />
                    <Route path='/resources' element={<Resourses />} />
                    <Route path='/translationJobs' element={<TranslationJobs />} />
                    <Route path='/postEditing' element={<PostEditing />} />
                    <Route path='/translations' element={<Translations />} />
                    <Route path='/inviteUsers' element={<InviteUsers />} />
                    <Route path='/portal-create' element={<PortalCreate />} />
                    <Route path='/recent-translations' element={<RecentTranslation />} />
                    <Route path='/preview-doc/:id' element={<PreviewDocuments />} />
                    <Route path='/edit-user/:id' element={<EditUser />} />
                    <Route path='/view-user/:id' element={<UserView />} />
                    <Route path='/choose-version' element={<SelectVersion />} />
                    <Route path='/system-logs' element={<SystemLogs />} />
                    <Route path='/system-logs/:id' element={<SystemLogView />} />
                    <Route path='/profile' element={<Profile />} />
                </Route>
            </Routes>
            <ToastContainer limit={2} />
            </AuthProvider>
        </Router>
    );
};

export default IndexRoute;